import * as React from "react";
import { LookGalleryDialog } from "./LookGalleryDialog";
import { useShareFlow } from "./ShareFlowProvider";
import { StyleCell } from "./StyleBar";

/** The look, for a prompt opened from the library: the design comes with it, so it's a setting that opens the gallery. */
export const LookCell: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const flow = useShareFlow();
  const [open, setOpen] = React.useState(false);
  const design = flow.design;
  if (!design) return null;

  return (
    <>
      <StyleCell
        label="Look"
        value={design.name}
        preview={
          design.thumbnailUrl ? <img src={design.thumbnailUrl} alt="" className="size-full object-cover" /> : null
        }
        disabled={disabled}
        open={open}
        onOpenChange={setOpen}
        data-testid="look-cell"
      />
      <LookGalleryDialog
        open={open}
        onOpenChange={setOpen}
        designs={flow.looks}
        loading={flow.designsLoading}
        selectedId={flow.designPackageId}
        onSelect={id => {
          if (id !== flow.designPackageId) flow.selectDesign(id);
        }}
        showMultiImageHint={flow.mode === "single"}
        hasMore={flow.designsHasMore}
        isLoadingMore={flow.designsLoadingMore}
        loadMoreFailed={flow.designsLoadMoreFailed}
        onLoadMore={flow.loadMoreDesigns}
      />
    </>
  );
};
